<template>
  <section class="header">
    <div
      class="header__hamburger lg:hidden cursor-pointer flex justify-between content-center"
      @click.stop.prevent="menuCollapsed = !menuCollapsed">
      <NuxtLinkLocale to="/">
          <EaslyLogoMobile alt="Logo" />
        </NuxtLinkLocale>
      <HamburgerIcon/>
    </div>
    <header
      id="PageHeader"
      class="header__wrapper"
      :class="[{ 'header__wrapper--collapsed': menuCollapsed }]">
      <div class="header__logo flex gap-3 items-center">
        <NuxtLinkLocale to="/">
          <EaslyLogo alt="Logo" />
        </NuxtLinkLocale>
        <div class="header__premium" v-if="isUserRole([UserRole.MANAGER, UserRole.SALES_REP]) && hasPremium">
          <NuxtLinkLocale to="/">
            <PremiumOn alt="PremiumLogo" />
          </NuxtLinkLocale>
        </div>
      </div>

      <nav class="header__menu">
        <ul
          v-if="!isUserRole(UserRole.MANAGER) || !isUserRole(UserRole.ADMIN)"
          class="header__menu-list">
          <template v-for="(menuItem, index) in menuList" :key="index">
            <li
              v-show="canShowMenuItem(menuItem)"
              v-if="menuItem.icon != 'chat'"
              v-cloak
              class="header__menu-link"
              @click.stop.prevent="menuCollapsed = !menuCollapsed"
            >
              <NuxtLinkLocale :to="menuItem.linkTo" :class="{
                       'router-link-active': route?.name?.includes(menuItem.linkTo) && menuItem.icon === 'marketplace'
                    }">
                <span
                  class="header__menu-img"
                  :class="[
                    `header__menu-img--${menuItem.icon}`,
                    {
                      'header__menu-img--chat-unread':
                        menuItem.icon === 'chat' && unreadMessages,
                    },
                  ]"></span>
                <span class="header__menu-txt" :class="[`${menuItem.icon}`]">{{ menuItem.label }}</span>
              </NuxtLinkLocale>
            </li>
            <!-- Temporary solution for chat -->
            <li
              v-show="canShowMenuItem(menuItem)"
              v-if="menuItem.icon == 'chat'"
              v-cloak
              class="header__menu-link">
              <a :href="'/' + locale + '/chat'"
                :class="[
                    {
                      'router-link-active': route.name.includes('chat')
                    }
                  ]">
                <span
                  class="header__menu-img"
                  :class="[
                    `header__menu-img--${menuItem.icon}`,
                    {
                      'header__menu-img--chat-unread':
                        menuItem.icon === 'chat' && unreadMessages,
                    },
                  ]"></span>
                <span class="header__menu-txt">{{ menuItem.label }}</span>
                  </a>
            </li>
          </template>
        </ul>
        <div v-if="authenticated" v-cloak class="header__profil ml-5">
          <div class="header__profil-icon">
            <button
              type="button"
              class="profil_account"
              @click="showProfileMenu = !showProfileMenu">
              <template v-if="!getUserInitials">
                <UserIcon />
              </template>
              <template v-else>
                {{ getUserInitials }}
              </template>
            </button>
            <ul class="user__profil" :class="{ show: showProfileMenu }">
              <li>
                <NuxtLinkLocale :to="getProfileHrefByUserRole">
                  <span class="icon">
                    <svg
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <mask
                        id="mask0_236_3326"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0">
                        <rect
                          x="0.457031"
                          y="0.679688"
                          width="24"
                          height="24"
                          fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_236_3326)">
                        <path
                          d="M6.30703 17.7797C7.15703 17.1297 8.10703 16.617 9.15703 16.2417C10.207 15.867 11.307 15.6797 12.457 15.6797C13.607 15.6797 14.707 15.867 15.757 16.2417C16.807 16.617 17.757 17.1297 18.607 17.7797C19.1904 17.0964 19.6447 16.3214 19.97 15.4547C20.2947 14.588 20.457 13.663 20.457 12.6797C20.457 10.463 19.678 8.57535 18.12 7.01669C16.5614 5.45869 14.6737 4.67969 12.457 4.67969C10.2404 4.67969 8.35303 5.45869 6.79503 7.01669C5.23636 8.57535 4.45703 10.463 4.45703 12.6797C4.45703 13.663 4.6197 14.588 4.94503 15.4547C5.2697 16.3214 5.7237 17.0964 6.30703 17.7797ZM12.457 13.6797C11.4737 13.6797 10.6444 13.3424 9.96903 12.6677C9.29436 11.9924 8.95703 11.163 8.95703 10.1797C8.95703 9.19635 9.29436 8.36702 9.96903 7.69169C10.6444 7.01702 11.4737 6.67969 12.457 6.67969C13.4404 6.67969 14.2697 7.01702 14.945 7.69169C15.6197 8.36702 15.957 9.19635 15.957 10.1797C15.957 11.163 15.6197 11.9924 14.945 12.6677C14.2697 13.3424 13.4404 13.6797 12.457 13.6797ZM12.457 22.6797C11.0737 22.6797 9.7737 22.417 8.55703 21.8917C7.34036 21.367 6.28203 20.6547 5.38203 19.7547C4.48203 18.8547 3.7697 17.7964 3.24503 16.5797C2.7197 15.363 2.45703 14.063 2.45703 12.6797C2.45703 11.2964 2.7197 9.99635 3.24503 8.77969C3.7697 7.56302 4.48203 6.50469 5.38203 5.60469C6.28203 4.70469 7.34036 3.99202 8.55703 3.46669C9.7737 2.94202 11.0737 2.67969 12.457 2.67969C13.8404 2.67969 15.1404 2.94202 16.357 3.46669C17.5737 3.99202 18.632 4.70469 19.532 5.60469C20.432 6.50469 21.1444 7.56302 21.669 8.77969C22.1944 9.99635 22.457 11.2964 22.457 12.6797C22.457 14.063 22.1944 15.363 21.669 16.5797C21.1444 17.7964 20.432 18.8547 19.532 19.7547C18.632 20.6547 17.5737 21.367 16.357 21.8917C15.1404 22.417 13.8404 22.6797 12.457 22.6797ZM12.457 20.6797C13.3404 20.6797 14.1737 20.5507 14.957 20.2927C15.7404 20.034 16.457 19.663 17.107 19.1797C16.457 18.6964 15.7404 18.3254 14.957 18.0667C14.1737 17.8087 13.3404 17.6797 12.457 17.6797C11.5737 17.6797 10.7404 17.8087 9.95703 18.0667C9.1737 18.3254 8.45703 18.6964 7.80703 19.1797C8.45703 19.663 9.1737 20.034 9.95703 20.2927C10.7404 20.5507 11.5737 20.6797 12.457 20.6797ZM12.457 11.6797C12.8904 11.6797 13.2487 11.538 13.532 11.2547C13.8154 10.9714 13.957 10.613 13.957 10.1797C13.957 9.74635 13.8154 9.38802 13.532 9.10469C13.2487 8.82135 12.8904 8.67969 12.457 8.67969C12.0237 8.67969 11.6654 8.82135 11.382 9.10469C11.0987 9.38802 10.957 9.74635 10.957 10.1797C10.957 10.613 11.0987 10.9714 11.382 11.2547C11.6654 11.538 12.0237 11.6797 12.457 11.6797Z" />
                      </g>
                    </svg>
                  </span>
                  <span>{{ $t('MY_ACCOUNT') }}</span>
                </NuxtLinkLocale>
              </li>
              <li>
                <button type="button" @click="logout()">
                  <span class="icon">
                    <svg
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg">
                      <mask
                        id="mask0_236_3323"
                        style="mask-type: alpha"
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0">
                        <rect
                          x="0.957031"
                          y="0.0742188"
                          width="24"
                          height="24"
                          fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_236_3323)">
                        <path
                          d="M5.95703 21.0742C5.40703 21.0742 4.93603 20.8786 4.54403 20.4872C4.1527 20.0952 3.95703 19.6242 3.95703 19.0742V5.07422C3.95703 4.52422 4.1527 4.05322 4.54403 3.66122C4.93603 3.26989 5.40703 3.07422 5.95703 3.07422H12.957V5.07422H5.95703V19.0742H12.957V21.0742H5.95703ZM16.957 17.0742L15.582 15.6242L18.132 13.0742H9.95703V11.0742H18.132L15.582 8.52422L16.957 7.07422L21.957 12.0742L16.957 17.0742Z"></path>
                      </g>
                    </svg>
                  </span>
                  <span>{{ $t('LOG_OUT') }}</span>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <LangSwitcher :type="'static'" />
    </header>
  </section>
</template>
<script lang="ts" setup>
import { useUserStore } from '~/stores/userStore'
import { UserRole } from '~/types/userRole'
import LangSwitcher from '~/components/shared/LangSwitcher.vue'
import EaslyLogo from '~/assets/img/common/easly-logo_white.svg?skipsvgo'
import PremiumOn from '~/assets/img/common/premium_on.svg?skipsvgo'
import EaslyLogoMobile from '~/assets/img/common/easly-logo_white_mobile.svg?skipsvgo'
import HamburgerIcon from '~/assets/img/icons/hamburger-icon.svg?skipsvgo'
import { isUserRole } from '~/composables/utils'
import Loader from '~/components/shared/Loader.vue'
import UserIcon from '~/assets/img/icons/user.svg?skipsvgo'
import { defineNuxtLink } from 'nuxt/app'
const { locale } = useI18n()
import { ref } from "vue"

const menuCollapsed = ref(false)

const { userInfo, hasPremium } = storeToRefs(useUserStore())

const { logoutUser } = useAuthStore()

const { authenticated } = storeToRefs(useAuthStore())

const localePath = useLocalePath()

const route = useRoute()

const unreadMessages = ref(false)
function getLocalePath(path: string) {
  switch (path) {
    case '/profile':
      if (userInfo.value.role === UserRole.MANAGER) {
        return localePath(`/manager/profile`)
      } else if (userInfo.value.role === UserRole.CLIENT) {
        return localePath(`/client/profile`)
      } else if (userInfo.value.role === UserRole.SALES_REP) {
        return localePath(`/sales/profile`)
      } else if (userInfo.value.role === UserRole.ADMIN) {
        return localePath(`/admin/profile`)
      }
      break
    default:
      return '/'
  }
}
const canShowMenuItem = computed(() => {
  return (item: any) => {
    if (authenticated.value && item.hideAfterAuth) return false
    if ('anonymous' in item) {
      if (authenticated.value && 'role' in item) {
        return item.role?.includes(userInfo.value.role)
      }

      return true
    }
    if ('role' in item) {
      return item.role?.includes(userInfo.value.role)
    }
    return false
  }
})

const getProfileHrefByUserRole = computed(() => {
  return localePath('/account-settings/data')
})

const { t: $t } = useI18n()

const menuList = ref([
    {
        label: $t('MENU.MY_ORDERS'),
        icon: 'marketplace',
        linkTo: localePath('/orders/my'),
        role: [
            UserRole.CLIENT,
        ],
    },
    {
        label: $t('MENU.FIND_CONTRACTORS'),
        icon: 'contractors',
        linkTo: localePath('/marketplace'),
        role: [
            UserRole.CLIENT,
        ],
    },
    {
        label: $t('MENU.MARKETPLACE'),
        icon: 'marketplace',
        linkTo: localePath('/orders/find'),
        anonymous: true,
        hideAfterAuth: true,
    },
    {
        label: $t('MENU.FIND_ORDERS'),
        icon: 'marketplace',
        linkTo: localePath('/orders/find'),
        role: [
            UserRole.MANAGER,
            UserRole.SALES_REP,
        ],
    },
  {
    label: $t('MENU.LOGIN'),
    icon: 'login',
    linkTo: localePath('/login'),
    anonymous: true,
    hideAfterAuth: true,
  },
  {
    label: $t('MENU.PROFILE'),
    icon: 'profile',
    linkTo: getLocalePath('/profile'),
    role: [
      UserRole.MANAGER,
      UserRole.CLIENT,
      UserRole.ADMIN,
      UserRole.SALES_REP,
    ],
  },
  {
    label: $t('MENU.CONTACT'),
    icon: 'contact',
    linkTo: localePath('/contacts'),
    role: [UserRole.CLIENT, UserRole.SALES_REP, UserRole.MANAGER],
  },
  {
    label: $t('MENU.CHAT'),
    icon: 'chat',
    linkTo: localePath('/chat'),
    role: [UserRole.CLIENT, UserRole.SALES_REP, UserRole.MANAGER],
  },
  {
    label: $t('MENU.ABOUT'),
    icon: 'info',
    linkTo: localePath('/about'),
    anonymous: true,
  },
  //{
  //  label: $t('MENU.BLOG'),
  //  icon: 'info',
  //  linkTo: localePath('/blog'),
  //  anonymous: true,
  //},
])

const { $socketUtils } = useNuxtApp()
const showProfileMenu = ref(false)

const router = useRouter()

function logout() {
  logoutUser()

  router.push(localePath('/logout'))
}

const { getUserInitials } = storeToRefs(useUserStore())

const getUnreadMessagesTimeout = ref(null)
async function getInfo() {
    const response = await $socketUtils.getUnreadMessages()
    unreadMessages.value =
        response.unreadMessages &&
        response.userCognitoIdsListeners.includes(userInfo.value.userId)
    await getUnreadMessagesStatus()
}
async function getUnreadMessagesStatus(init = false) {
  if (isUserRole.value([UserRole.ADMIN, UserRole.MANAGER])) {
    return
  }

  if (init) {
    await getInfo()
    return
  }

  getUnreadMessagesTimeout.value = setTimeout(async () => {
      await getInfo()
  }, 15000)
}

onMounted(async () => {
  if (authenticated.value) {
   await getUnreadMessagesStatus(true)
  }
})

onUnmounted(() => {
  clearTimeout(getUnreadMessagesTimeout.value)

  $socketUtils.disconnect()
})
</script>
<style lang="scss" scoped>
:root {
  /* Set Breakpoints */
  --desktop: 1920;
  /* default Figma size */
  --mobile: 768;
  --mobile_px: 768px;
  /* Formula */
  --count-size: ((100vw - var(--mobile_px)) / (var(--desktop) - var(--mobile)));
}

/*===========================================================Desktop: header area,Mobile: footer area===========================================================*/
.header {
  position: sticky;
  top: 0;
  grid-area: header;
  font-size: calc(14px + (16 - 14) * var(--count-size));
  font-weight: var(--font-bold);
  background-color: #353535;
  z-index: 11;
  display: flex;
  width: 100%;
  height: 80px;
  align-items: center;
  justify-content: space-between;
  @media screen and (max-width: 767px) {
    align-items: center;
  }

  &__wrapper {
    width: 100%;
    height: max-content;
    display: grid;
    grid-template-columns: 4rem min-content auto min-content 4rem;
    align-content: center;
  }
  @media screen and (max-width: 1023px) {
    &__wrapper {
      display: flex;
      flex-direction: column;
      transform: translateX(-100%);
      transition: transform 0.2s ease;
      position: fixed;
      left: 0;
      top: 0;
      height: 100vh;
      width: 100%;
      max-width: 75vw;
      overflow: hidden;
      background-color: hsl(0deg 0% 21.41% / 70%);
      backdrop-filter: blur(0.75em);
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.38);
      padding: 35px 25px;
      &--collapsed {
        transform: translateX(0%);
      }

      .lang-switcher {
        margin-top: auto;
      }
    }
    &__wrapper &__menu {
      display: flex;
      flex-direction: column-reverse;
      align-items: flex-end;
    }
    &__wrapper &__menu-list {
      width: 100%;
      margin-top: 30px;
      grid-auto-flow: row;
    }
  }
  &__profil {
    &-icon {
      position: relative;
    }
  }

  &__hamburger {
    width: 100%;
    /*height: 40px*/;
    padding: 15px;
    box-sizing: content-box;
  }
}

@media screen and (min-width: 1920px) {
  .header {
    height: 80px;
    font-size: 18px;
  }
}

@media screen and (max-width: 1440px) {
  .header {
    grid-template-columns: 3rem min-content auto min-content 3rem;
    height: 60px;
    font-size: 14px;
  }
}
@media screen and (max-width: 1280px) {
  .header {
    z-index: 1000;
    &__wrapper {
      grid-template-columns: 3rem min-content auto min-content 3rem ;
    }
    &__menu {
      margin-right: 0.5rem !important;
      &-list {
        gap: 0.75rem !important;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .header {
    grid-area: footer;
    height: 80px;
    font-size: 16px;
  }
}

/*--- */
.header__logo {
  grid-column: 2/3;
}

.header__menu {
  grid-column: 3/4;
  margin-right: 4%;
}

.header__profil {
  grid-column: 4/5;
}

.header__menu,
.header__profil {
  display: grid;
  justify-content: end;
  align-items: center;
}

@media screen and (max-width: 768px) {
  .header {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }

  .header__logo,
  .header__profil,
  .header__menu-link span.header__menu-txt {
    //display: none;
  }

  .header__menu {
    grid-column: 2/3;
    justify-content: normal;
    margin-right: 0;
  }
}

/* 1.============ Logo =========== */
.header__logo {
  width: calc(80px + (105 - 80) * var(--count-size));
}

@media screen and (max-width: 1440px) {
  .header__logo {
    width: 80px;
  }
}

@media screen and (min-width: 1920px) {
  .header__logo {
    width: 105px;
  }
}

.header__logo a {
  display: inline-block;
}

.header__logo a:hover {
  animation: animRotate 1s ease-in-out;
  -webkit-animation: animRotate 1s ease-in-out;
  -moz-animation: animRotate 1s ease-in-out;
}

/* 2.============ Menu ========== */
.header__menu-list {
  display: grid;
  grid-auto-flow: column;
  gap: 2rem;
  align-items: center;
  margin: 0;
}

@media screen and (max-width: 768px) {
  .header__menu-list {
    gap: 2rem !important;
    justify-content: space-between;
  }
}

@media screen and (max-width: 1440px) {
  .header__menu-list {
    gap: 2rem;
  }
}

.header__menu-link a,
.header__menu-link span {
  display: inline-block;
}

.header__menu-link a {
  display: flex;
  align-items: center;
  gap: 0.7em;
}

/* ========= Color Menu Icon SVG ========== */
a:hover svg path,
a:hover svg ellipse,
a.active svg path,
a.active svg ellipse {
  fill: var(--light-color);
}

/* Profil icon Frame White */
a:hover svg#profil_icon path,
a.active svg#profil_icon path {
  fill: var(--primary-color);
}

a:hover svg#profil_icon rect,
a.active svg#profil_icon rect {
  fill: var(--light-color);
}

.header__menu-link a {
  --bg-color: #3870ff;
  --text-color: #fff;
  color: var(--text-color);
  transition: color 0.15s ease;

  .header__menu-img {
    --bg-color: inherit;
    background-color: var(--bg-color);
    transition: background-color 0.15s ease;
  }
  &:hover {
    --text-color: #b2b2b2;
    --bg-color: #6e97ff;
  }
  &.router-link-active {
    --bg-color: #ffa800;
  }
}

/* === Img Menu === */
.header__menu-img {
  width: calc(19px + (26 - 19) * var(--count-size));
  aspect-ratio: 1;
  mask-repeat: no-repeat;
  mask-size: contain;

  &--marketplace {
    mask-image: url('@/assets/img/icons/marketplace_icon.svg');
  }
  &--profile {
    mask-image: url('@/assets/img/icons/profil_icon.svg');
  }
  &--contact {
    mask-image: url('@/assets/img/icons/contact_icon.svg');
  }
  &--chat {
    mask-image: url('@/assets/img/icons/chat_icon.svg');
    &-unread {
      --bg-color: transparent !important;
      mask-image: none;
      background: url('@/assets/img/icons/chat_icon-active.svg') no-repeat
        center / contain;
    }
  }
  &--contractors {
    mask-image: url('@/assets/img/icons/contractors_icon.svg');
  }
  &--info {
    mask-image: url('@/assets/img/icons/info.svg');
  }
  &--login {
    mask-image: url('@/assets/img/icons/login.png');
  }
  &--register {
    mask-image: url('@/assets/img/icons/register.svg');
  }
}

@media screen and (max-width: 768px) {
  .header__menu-img {
    width: 26px;
  }
}

@media screen and (max-width: 1440px) {
  .header__menu-img {
    width: 20px;
  }
}

.active .header__menu-img {
  width: calc(19px + (33 - 19) * var(--count-size));
}

@media screen and (max-width: 768px) {
  .active .header__menu-img {
    width: 33px;
  }
}

@media screen and (max-width: 1440px) {
  .active .header__menu-img {
    width: 19px;
  }
}

/* 3.========= Profil Icon ========= */
.header__profil-icon .profil_account {
  display: block;
  width: calc(32px + (43 - 32) * var(--count-size));
  height: calc(32px + (43 - 32) * var(--count-size));
  line-height: calc(32px + (43 - 32) * var(--count-size));
  font-size: calc(11px + (15 - 11) * var(--count-size));
  text-align: center;
  color: var(--light-color);
  background-color: #353535;
  border: 1px solid var(--light-color);
  border-radius: 50%;
}

.header__profil-icon .profil_account svg {
  margin:0 8px;
  filter: invert(100%) brightness(100%);
}

.header__profil-icon .profil_account:hover {
  color: var(--primary-color);
  background-color: var(--light-color);
}
.header__profil-icon .profil_account:hover svg {
  filter: invert(0%) brightness(0%);
}
@media screen and (max-width: 1660px) {
  .header__profil-icon .profil_account svg {
  margin:0 7px;
}
}
@media screen and (max-width: 1440px) {
  .header__profil-icon .profil_account {
    width: 32px;
    height: 32px;
    line-height: 32px;
    font-size: 11px;
  }
  .header__profil-icon .profil_account svg {
    margin-left: 3px;
  }
}

@media screen and (min-width: 1920px) {
  .header__profil-icon .profil_account {
    width: 43px;
    height: 43px;
    line-height: 43px;
    font-size: 15px;
  }
}

/* === Account Profil === */
.user__profil {
  display: none;
  position: absolute;
  top: 110%;
  right: 0;
  z-index: 199;
  background: #353535;
  border-radius: 10px;
  &.show {
    display: block;
  }

  li {
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid #fff;
    &:last-child {
      border-bottom: none;
    }
  }

  button,
  a {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.5rem;
    color: var(--grey-color);
    &:hover {
      color: var(--light-color);
      svg {
        fill: var(--light-color);
      }
    }

    span {
      display: inline-block;
      font-family: var(--font-body);
      font-weight: var(--font-bold);
      font-size: calc(11px + (16 - 11) * var(--count-size));
      text-align: left;
      width: max-content;
    }

    svg {
      width: calc(15px + (20 - 15) * var(--count-size));
      height: calc(15px + (20 - 15) * var(--count-size));
      fill: var(--grey-color);
    }
  }
}
</style>
